export default __webpack_public_path__ + "static/media/photo--sm--128.6ce8b5ed.jpg";